// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import Icon_google from '../../img/icons/24/color/google.svg';
import {perr} from 'hola_pub_util';
import Icon_trustpilot from '../../../../toolip/pub/img/trustpilot_micro.svg';
import {Lottie} from '../../../../hola/pub/lib/lottie';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Button} from '../../lib/button';
import {use_login} from '../navbar/use_login';
import {Map} from '../../../../toolip/pub/ui/landings/map';
import styles from './hero.module.less';
import anim_styles from '../../../../toolip/pub/ui/animation.module.less';
import Svg_bg_left from '../../img/homepage/hero_left.svg';
import Svg_bg_right from '../../img/homepage/hero_right.svg';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {Input} from '../../../../hola/pub/lib/input';
import {Checkbox} from '../../lib/checkbox';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_hero_props {
    cta?: string;
    cta_link?: string;
    with_bg_blur?: boolean;
    title?: string;
    title_tag?: string;
    subtitle?: string;
    with_map?: boolean;
}

interface i_hero_editor_props {
    value: i_hero_props;
    on_change: (v:i_hero_props)=>void;
    on_cancel: ()=>void;
}

export const Hero_editor = (props: i_hero_editor_props)=>{
    const [state, set_state] = useState<i_hero_props>(props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    return <div>
      <Input size={'sm'} label={'title (html)'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.title_tag} on_select={v=>
        set_state({...state, title_tag: v})}/>
      <Input size={'sm'} label={'subtitle (html)'} value={state.subtitle || ''}
        on_change={v=>set_state({...state, subtitle: v})}/>
      <Input size={'sm'} label={'cta'} value={state.cta || ''}
        on_change={v=>set_state({...state, cta: v})}/>
      <Input size={'sm'} label={'cta_link'} value={state.cta_link || ''}
        on_change={v=>set_state({...state, cta_link: v})}/>
      <Checkbox checked={!!state.with_bg_blur} caption={'with_bg_blur'}
        on_change={v=>set_state({...state, with_bg_blur: v})}/>
      <Checkbox checked={!!state.with_map} caption={'with_map'}
        on_change={v=>set_state({...state, with_map: v})}/>
      <br/>
      <Button caption={'Save'} size={'s'}
        on_click={()=>props.on_change(state)}/>
      <Button caption={'Cancel'} size={'s'} on_click={()=>props.on_cancel()}/>
    </div>;
};

export const Hero = (props: i_hero_props)=>{
    const cta_text = props.cta || 'Try now';
    const cta_link = props.cta_link || '/pricing';
    const title = props.title || 'Global Proxy Network';
    const subtitle = props.subtitle ||
        `Choose & connect to proxies from 50+ Countries. <br/>
        Proxies available in United States, France, Germany, UK,
        Netherlands and many more.`;

    const {theme} = useContext(Settings_context);
    const {on_login} = use_login(true, '/dashboard');
    const {user} = use_app_context();
    return <div className={styles.hero_wrapper}>
      {props.with_bg_blur &&
          <div className={styles.bg_blur}/>}
      <div className={styles.hero}>
        {!props.with_bg_blur && <div className={styles.hero_bg}>
          <Svg_bg_left className={styles.bg_left}/>
          <Svg_bg_right className={styles.bg_right}/>
          <div className={styles.bg_center}/>
        </div>}
          <div className={cn(theme.container, styles.container)}>
            <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
              <p className={cn(theme.mono14, styles.uptime)}>
                <Lottie autoplay loop width="20px" height="14px"
                  src={oculus_img_url('animation/uptime.json')}/>
                <span>Uptime: <b>99.9%</b></span>
              </p>
            </div>
            <div className={styles.hero_text_wrapper}>
              <Dynamic_heading className={cn(styles.hero_title,
                anim_styles.hero_showup_2)} tag={props.title_tag}
                dangerouslySetInnerHTML={{__html: title}}/>
              <p className={cn(theme.p16, theme.med, styles.sub_title,
                anim_styles.hero_showup_2)}
                dangerouslySetInnerHTML={{__html: subtitle}}/>
              <div className={cn(styles.hero_cta, anim_styles.hero_showup_3)}>
                <Button caption={<>{cta_text} <Icon_arrow_right/></>}
                  size={'l'} to={cta_link}
                  on_click={()=>{
                    perr({id: 'oculus_homepage_hero_cta_click'});
                  }}
                />
                {!user && <Button caption={<><Icon_google/> Sign in
                  with Google</>}
                  size={'l'} color={'social'}
                  on_click={ev=>{
                    on_login(ev);
                    perr({id: 'oculus_homepage_signin_click'});
                  }}
                />}
              </div>
              <p className={cn(theme.p12, theme.med, styles.hero_cta_text,
                anim_styles.hero_showup_3)}>* No credit card needed. Free
                  plan available.</p>
              <a href="https://www.trustpilot.com/review/oculusproxies.com"
                target="_blank" rel="noopener noreferrer"
                className={cn(anim_styles.hero_showup_4, styles.trustpilot,
                  styles.alt_trustpilot)}>
                <Icon_trustpilot/>
              </a>
            </div>
          </div>
      </div>
      {props.with_map && <div className={cn(styles.map_container,
        anim_styles.hero_showup_5, styles.country)}>
        <Map shown_in_home={true}/>
      </div>}
    </div>;
};
